import type { CoinView } from './model';

export function predictionMultiplier(coin: Pick<CoinView, 'split' | 'choice'>) {
  const validSplit =
    coin.split !== null &&
    Number.isFinite(coin.split) &&
    coin.split >= 0 &&
    coin.split <= 100;
  const share =
    validSplit && coin.choice
      ? coin.choice === 'SURVIVES'
        ? coin.split!
        : 100 - coin.split!
      : null;
  const multiplier = share !== null && share > 0 ? 100 / share : null;
  return multiplier !== null && Number.isFinite(multiplier) ? multiplier : null;
}

export function betMultiplier(coin: CoinView) {
  if (coin.simulated) return predictionMultiplier(coin);
  const coefficient = Number(coin.lockedOdds?.coefficient);
  return coin.choice && Number.isFinite(coefficient) && coefficient >= 1
    ? coefficient
    : null;
}

export function predictionState(coin: CoinView, now: number) {
  const kind =
    coin.phase === 'settled' && coin.outcome !== null
      ? 'final'
      : now >= coin.settlesAt
        ? 'pending'
        : now < coin.closesAt
          ? 'bought'
          : 'result';
  const active = kind === 'bought' || kind === 'result';
  const origin = kind === 'bought' ? coin.start : coin.closesAt;
  const target = kind === 'bought' ? coin.closesAt : coin.settlesAt;
  const total = Math.max(1, target - origin);
  const elapsed = Math.min(total, Math.max(0, now - origin));
  return {
    kind,
    active,
    tone:
      kind === 'bought'
        ? 'waiting'
        : kind === 'pending'
          ? 'neutral'
          : coin.choice === 'SURVIVES'
            ? 'up'
            : 'down',
    label: kind === 'bought' ? 'Prediction closes' : 'Results in',
    total,
    elapsed,
    remaining: Math.max(0, target - now),
    multiplier: betMultiplier(coin),
    timing: [coin.id, kind, origin, target].join(':'),
  };
}
